// extracted by mini-css-extract-plugin
export default {"courseSection":"CourseSection_courseSection__EWa3Z"};